export default "__VITE_ASSET__C0b5w7Ki__"